import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MainLayout from './MainLayout';

const ProjectHistory = () => {
  const [projects, setProjects] = useState([]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await axios.get('https://openmkm.vidyayug.com/api/projects/history', {
          headers: { Authorization: token },
        });
        setProjects(res.data.projects);
      } catch (err) {
        console.error('Failed to fetch history', err);
      }
    };

    fetchHistory();
  }, [token]);

  return (
    <MainLayout>
      <h2>Uploaded Project History</h2>
      {projects.length === 0 ? (
        <p>No projects uploaded yet.</p>
      ) : (
        <div style={styles.list}>
          {projects.map((project) => (
            <div key={project.project_id} style={styles.card}>
              <h4>{project.project_id}</h4>
              <p><strong>Uploaded:</strong> {new Date(project.created_at).toLocaleString()}</p>
              <p><strong>Files:</strong></p>
              <ul>
                {project.files.map((f, idx) => (
                  <li key={idx}>{f}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </MainLayout>
  );
};

const styles = {
  list: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '20px',
    marginTop: '20px',
  },
  card: {
    padding: '20px',
    background: '#fff',
    borderRadius: '6px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
};

export default ProjectHistory;
